import React from "react";
import { Link } from "react-router-dom";

const NavBarMobile = ({ textes, isBackgroundWhite = false }) => {
  return (
    <nav className="fixed top-0 left-0 w-full bg-black bg-opacity-0 z-50 flex justify-center items-center">
      <div className="container mx-auto flex items-center justify-between py-4 px-6">
        <div className="flex items-center">
          <Link
            to={"/"}
            className={
              "font-sam text-[5em] font-thin " + (isBackgroundWhite ? "text-black" : "text-white")
            }
          >
            SAM
          </Link>
        </div>
        <ul className="flex items-center ml-auto">
          <li
            className={
              "mx-2 font-lexend text-[2em] hover:text-[#039b7c]" +
              (isBackgroundWhite ? " text-black" : " text-white")
            }
          >
            <Link to={"/#" + textes?.navBarItem2}>{textes?.navBarItem2}</Link>
          </li>
          <li
            className={
              "mx-2 font-lexend text-[2em] hover:text-[#039b7c]" +
              (isBackgroundWhite ? " text-black" : " text-white")
            }
          >
            <Link to="/contact">{textes?.navBarItem1}</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default NavBarMobile;